var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapedBackgroundHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6912,
    viewBox: "0 0 5184 2592",
    height: 3456,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4578.95 0h229.523v828h-229.524zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4308.156 0H4515v828h-206.844zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4263.602 2246h613.789v345H4263.6zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4570.496 2246.875c-169.488 0-306.894 137.406-306.894 306.895 0 70.945 24.09 136.27 64.5 188.261h484.789c40.437-51.992 64.5-117.316 64.5-188.261 0-169.489-137.407-306.895-306.895-306.895zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4044.39 1819.492h662.79v662.79h-662.79zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4375.785 2438.438c158.813 0 287.55-128.743 287.55-287.551h21.923-21.922c0-158.813-128.738-287.551-287.55-287.551v-21.922 21.922c-158.81 0-287.552 128.738-287.552 287.55h-21.921 21.921c0 158.81 128.743 287.552 287.551 287.552v21.921-21.921m0 43.843c-183.027 0-331.394-148.367-331.394-331.394 0-183.028 148.367-331.395 331.394-331.395 183.028 0 331.395 148.367 331.395 331.395 0 183.027-148.368 331.394-331.395 331.394zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4339.363-64.375 123.66 146.148-154.867 183.051 154.867 183.055-154.867 183.055 167.297 197.726 26.613-29.375-142.433-168.351L4514.5 447.879l-154.867-183.055L4514.5 81.774 4390.84-64.376zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4613.66-64.375 137.563 146.148-172.274 183.051 172.274 183.055-172.274 183.05 186.094 197.727 29.605-29.375L4636.2 630.93l172.274-183.051-172.274-183.055 172.274-183.05-137.559-146.149zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h1508v2591H1zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-970.598 173.79 1255.32-491.563 1235.544 3155.257-1255.317 491.563zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-970.598 173.79 1247.43-488.474 1235.426 3154.961L264.832 3328.75zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1964.875h778v229.523H1zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-114.277 2159.688 146.148-137.56 183.05 172.27 183.056-172.27 183.05 172.27 197.727-186.093-29.375-29.606-168.352 158.45-183.05-172.274-183.055 172.273-183.05-172.273-146.15 137.559zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8d04f",
    d: "M4308.156-64.375h206.317v892.313h-206.317zm0 0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4de2bf",
    d: "M4031.496 1806.598h858.79v949.05h-858.79zm0 0"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4031.496 1806.598h858.79v949.05h-858.79zm0 0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8d04f",
    d: "M4578.95-64.375h229.523v892.309h-229.524zm0 0"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4de2bf",
    d: "M-970.598 173.79 273.414-313.345l1235.543 3155.258-1244.008 487.133zm0 0"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-114.277 2194.398v-229.523H778.03v229.523zm0 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapedBackgroundHero);
export default __webpack_public_path__ + "static/media/shaped_background_hero.094269b45602814a9ff8d1e7fd47cd4c.svg";
export { ForwardRef as ReactComponent };